import {
  BillingCycleType,
  ICalculateAutomatedPdfPlan,
  ICalculateEstimateItem,
  ProductType,
} from '../../../types/payment.type';
import {MultiSite} from 'src/app/types/site.type';
import {createStore, withProps} from '@ngneat/elf';

export interface PaymentDataState {
  selectedProduct: ProductType;
  sites: MultiSite[];
  isTrialActive: boolean;
  isSwitchingToAnnual: boolean;
  isSubscriptionOnTrialPeriod: boolean;
  customerId: string;
  billingCycle: BillingCycleType;
  estimatedProductData: ICalculateEstimateItem[];
  automatedPdfPlan: ICalculateAutomatedPdfPlan[];
  isOnTrialPeriod: boolean;
  baseDiscountPercentBiAnnual: number;
  baseDiscountPercentYearly: number;
  isLoading: boolean;
  isPaymentLink: boolean;
}

export function createInitialPaymentState(): PaymentDataState {
  return {
    selectedProduct: ProductType.Remediation,
    isTrialActive: false,
    isSwitchingToAnnual: false,
    isSubscriptionOnTrialPeriod: false,
    sites: [],
    customerId: null,
    billingCycle: null,
    estimatedProductData: null,
    automatedPdfPlan: null,
    isOnTrialPeriod: false,
    baseDiscountPercentYearly: null,
    baseDiscountPercentBiAnnual: null,
    isLoading: false,
    isPaymentLink: false,
  };
}

export const paymentDataStore = createStore(
  {name: 'payment'},
  withProps<PaymentDataState>(createInitialPaymentState()),
);
